<template>
  <main class="queryDetail container-fluid mf_container pb_50 mb_20">
    <div class="row mt_15">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-default" @click="goback()">重新搜尋</button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="selectInsered" v-if="is_crm == '1'">
          <h4>請選擇被保險人:</h4>
          <div class="selectInsered__list pt_7">
            <div
              class="inseredTab mr_5 mb_10"
              :class="{ active: people.csidno == nowShowInsuredId }"
              @click="changeShowInsured(people)"
              v-for="people in getAllFamilyResult"
              :key="people.csidno"
            >
              <Avatar
                class="mr-2"
                :gender="Number(people.sex)"
                :size="20"
                :height="20"
              />
              <div class="inseredTab__name">{{ truncate(people.name) }}</div>
            </div>
          </div>
        </div>
        <!-- 傳統型列表 -->
        <div v-if="proposalDetailList_TD.length > 0">
          <div class="queryDetail__title mt_10">
            <div
              class="queryDetail__title--tag"
              style="background-color: #027a39"
            ></div>
            <h5>傳統型商品</h5>
          </div>
          <QueryContractItemTD
            v-for="(contractItem, index) in proposalDetailList_TD"
            :NO="(contractItem.NO = proposalDetailList_TD.length - index)"
            :key="contractItem.prod_idx"
            :contractData="contractItem"
            :selected.sync="nowSelectProposal"
            @select-contract-date-handler="selectContractDateHandler($event)"
            @delete-proposal="deleteProposal"
            @features-handler="featuresHandler($event)"
            @route-to-cust-detail="routeToCustDetailFromTD"
            selectedMode="radio"
          ></QueryContractItemTD>
        </div>
        <!-- 投資型列表 -->
        <div v-if="proposalDetailList_IV.length > 0">
          <div class="queryDetail__title mt_10">
            <div
              class="queryDetail__title--tag"
              style="background-color: #a0a0f0"
            ></div>
            <h5>投資及指數型商品</h5>
          </div>
          <QueryContractItemIV
            v-for="(contractItem, index) in proposalDetailList_IV"
            :NO="proposalDetailList_IV.length - index"
            :key="contractItem.prod_idx"
            :contractData="contractItem"
            :selected.sync="nowSelectProposal"
            @select-contract-date-handler="selectContractDateHandler($event)"
            @delete-proposal="deleteProposal"
            @features-handler="featuresHandler($event)"
            @route-to-cust-detail="routeToCustDetailFromTD"
            :proposal-iv-sc-length="
              proposalDetailList_IV.sc_prod_list
                ? proposalDetailList_IV.sc_prod_list.length
                : 0
            "
            selectedMode="radio"
          ></QueryContractItemIV>
        </div>
        <div
          class="queryDetail__empty"
          v-if="
            proposalDetailList_TD.length == 0 &&
            proposalDetailList_IV.length == 0
          "
        >
          {{ emptyText }}
        </div>
      </div>
    </div>
    <ChangePopup
      :crmMapList="crmMapList"
      :oldCrmMapList="oldCrmMapList"
      v-if="changePopupHandler"
      @cancel="changePopupHandler = false"
      @finish="toHandler"
    />
    <!-- <FixedBottom
      v-show="
        proposalDetailList_TD.length > 0 || proposalDetailList_IV.length > 0
      "
    >
      <template slot="@function">
        <div class="d-flex justify-content-end">
          <router-link class="btn btn-default" to="/mf/query/queryDetail"
            >查詢其他建議書
          </router-link>
        </div>
      </template>
    </FixedBottom> -->
    <form
      :action="`${formSubmitURL}cathaylife.com.tw/ATWeb/servlet/HttpDispatcher/ATA0_7500/query`"
      method="GET"
      ref="submit"
      style="display: none"
      target="_blank"
      accept="BIG5"
      accept-charset="BIG5"
    ></form>
  </main>
</template>

<script>
import { computeAge, getCustInfo, getAllFamily } from "@/service";
import _ from "lodash";
import mf_Mixin from "@/desktop/views/mf/mixin";
import Avatar from "@/desktop/components/Avatar";
import QueryContractItemTD from "@/desktop/views/mf/components/QueryContractItem_TD";
import QueryContractItemIV from "@/desktop/views/mf/components/QueryContractItem_IV";
import IV_DEMO from "../../mock/IV_porposal.js";

import FixedBottom from "@/desktop/views/mf/components/fixedBotton";
import ChangePopup from "@/desktop/views/mf/components/2.Query/2-3-1.QueryDetail/ChangePopup.vue";

export default {
  mixins: [mf_Mixin],
  components: {
    Avatar,
    QueryContractItemTD,
    QueryContractItemIV,
    FixedBottom,
    ChangePopup,
  },
  data() {
    return {
      getAllFamilyResult: [], //加戶列表
      nowShowInsuredId: "", //目前檢視的被保人ID
      proposalDetailList_TD: [], //傳統型列表
      proposalDetailList_IV: [], //投資型列表
      proposal_IV_SC_length: [], //投資型列表附約
      nowSelectProposal: null,
      tempNowSelectProposal: null, //已壓上新資料重算，但不確定是user是否使用的暫存
      emptyText: "查詢中...",
      crmMapList: {},
      oldCrmMapList: {}, //出現差異的人們
      changePopupHandler: false,
      toHandler: () => {},
      memberRiskObjList: {}, // riskListObj
      proposal_item: {},
      dividendProductList: [], // 分紅商品清單
    };
  },
  computed: {
    is_crm() {
      return this.$store.getters.QueryDetailTarget.is_crm;
    },
    insured_id() {
      return this.$store.getters.QueryDetailTarget.insured_id;
    },
    prod_idx() {
      return this.$store.getters.QueryDetailTarget.prod_idx;
    },
    familyid() {
      return this.$store.getters.QueryDetailTarget.familyid;
    },
    isIV() {
      return this.nowSelectProposal.prod_type !== "1";
    },
    isIUL() {
      return this.nowSelectProposal.prod_type == "5";
    },
    kycRiskObjText() {
      return this.$store.getters.kycRiskObjText;
    },
     //是否含無身分證
    includeNoId() {
      return (
        this.nowSelectProposal.insured_id.indexOf("~") > -1 ||
        this.nowSelectProposal.insurer_id.indexOf("~") > -1 ||
        this.nowSelectProposal.mc_prod_list.some((mc) => {
          return mc.sc_prod_list.some((sc) => {
            return sc.insured_id.indexOf("~") > -1;
          });
        })
      );
    },
        formSubmitURL() {
          let href = window.location.href; // 設定動態 url
          let netzone = "https://twas2.";
          if (href.indexOf("tmycrm") !== -1) {
            netzone = "https://twas2.";
          } else if (href.indexOf("smycrm") !== -1) {
            netzone = "https://swas2.";
          } else if (href.indexOf("mycrm") !== -1) {
            netzone = "https://was2.";
          }
          return netzone;
        }
  },
  beforeCreate() {},
  created() {
    if (this.$store.getters.QueryDetailTarget.is_crm == "") {
      return this.$router.replace("/mf/query");
    }
    this.currTranser();
    this.init();
  },
  methods: {
    async init() {
      this.kycRiskObjText;
      if (this.is_crm == "1") {
        const result = await getAllFamily(
          this.$store.state.userInfo.id,
          this.familyid,
          this.$store.getters.IsBankUser,
        );
        this.getAllFamilyResult = result.data;
        await this.riskPOPText(this.getAllFamilyResult); // 投資型商品判斷商品kyc風險屬性顯示文字打API
        this.crmMapList = {}; //家戶現況原始資料
        result.data.forEach((item) => {
          this.crmMapList[item.csidno] = {
            insured_name: item.name,
            insured_birthday: item.birthday || "",
            insured_gender: item.sex,
            insured_age: item.age + "",
          };
        });
        // this.nowShowInsuredId = result.data[0].csidno;
        this.nowShowInsuredId = this.insured_id;
      } else {
        this.nowShowInsuredId = this.insured_id;
      }
      this.$store.commit("set_proRiskObj", ""); // 清空舊有store 投資型商品風險屬性顯示文字
      this.getProposalDetailList();
    },
    async getProposalDetailList() {
      this.$store.commit("update_mfLoadingMask", true);
      try {
        const [res_TD, res_IV] = await Promise.all([
          this.$mfAPI.MFA0_1000__queryProposalDetailList({
            agent_id: this.$store.state.userInfo.id,
            insured_id: this.nowShowInsuredId,
            prod_idx: this.prod_idx,
          }),
          this.$mfAPI.MFA1_1000__queryProposalDetailList({
            agent_id: this.$store.state.userInfo.id,
            insured_id: this.nowShowInsuredId,
            prod_idx: this.prod_idx,
          }),
        ]);

        this.proposalDetailList_TD = res_TD.proposal.map((item) => {
          item.prod_type = "1";
          item.isDividend = item.mc_prod_list.some(
            (item) => item.life_pol_design_type !== "2",
          );
          return item;
        });
        this.proposalDetailList_IV = res_IV.proposal.map((item) => {
          item.prod_type = "2";
          if (
            item.mc_prod_list[0] &&
            item.mc_prod_list[0].prod_type &&
            item.mc_prod_list[0].prod_type == "5"
          ) {
            item.prod_type = "5";
          }
          item.mc_prod_list[0].riskObj =
            this.memberRiskObjList[item.insurer_id];
          return item;
        });

        this.$store.commit("update_mfLoadingMask", false);
        this.emptyText = "尚未為客戶新增建議書，故無可查詢資訊";
        setTimeout(() => {
          this.registerHanlink();
        }, 500);
      } catch {
        this.$store.commit("update_mfLoadingMask", false);
      }
    },
    async riskPOPText(selectedList) {
      let APC_IDList = [];
      this.$store.commit("set_allRiskObj", ""); //舊有家戶 riskObj 清空
      this.$store.commit("set_kycRiskObj", ""); // 目前建議書POP清空
      selectedList.filter((item) => {
        let obj = {
          APC_ID: item.csidno,
          BRDY: item.birthday,
        };
        APC_IDList.push(obj);
      });
      await this.$mfAPI
        .MFA1_0100__getKYCInfo({
          APC_IDs: APC_IDList,
        })
        .then((res) => {
          this.$store.commit("set_allRiskObj", res);
          this.memberRiskObjList = res;
          this.$forceUpdate();
        })
        .catch((error) => {
          this.$toast.info({
            title: "風險屬性檢核異常，您可以稍後再重新確認",
          });
        });
    },
    changeShowInsured(people) {
      this.proposalDetailList_TD = [];
      this.proposalDetailList_IV = [];
      this.emptyText = "查詢中...";
      this.nowShowInsuredId = people.csidno;
      // this.$store.commit("update_queryDetailTarget", {
      //   ...this.$store.getters.QueryDetailTarget,
      //   insured_id: people.csidno,
      //   is_crm: "1",
      // });
      this.getProposalDetailList();
    },
    goback() {
      this.$router.push(`/mf/query${this.is_crm == "0" ? "?noId=1" : ""}`);
      this.$store.commit("reset_Customer");
      this.getAllFamilyResult = [];
      this.proposalDetailList_TD = [];
      this.proposalDetailList_IV = [];
    },
    routeToCustDetailFromTD(custId) {
      this.featuresHandler({
        mode: "routeToCustDetail",
        custId,
      });
    },
    async featuresHandler(mode) {
      let routeToCustDetailId = "";
      if (typeof mode === "object") {
        routeToCustDetailId = mode.custId;
        mode = mode.mode;
      }
      const isRouteToCustDetail = mode === "routeToCustDetail";
      if (!this.nowSelectProposal) {
        return this.$toast.info({ title: `請先選擇一組建議!` });
      }
      let autoDeleteSet = new Set(); //資動刪除清單，提示用
      let tempNowSelectProposal = _.cloneDeep(this.nowSelectProposal);
      if (mode != "edit" && !isRouteToCustDetail) {
        let mc_prod_list = tempNowSelectProposal.mc_prod_list;

        for (let i = 0; i < mc_prod_list.length; i++) {
          let mc = mc_prod_list[i];
          let message = await this.checkProdWhiteList(
            mc.prod_id,
            tempNowSelectProposal.insured_id,
          );
          if (message != "") {
            this.canSave = true;
            return this.$toast.info({
              title: message,
            });
          }
        }
      }

      let isStopSale = false;
      //$空白建議書，增齡機制
      var isAddAge_noId = false;
      if (
        tempNowSelectProposal.insured_id == "" &&
        tempNowSelectProposal.insured_birthday
      ) {
        let res_new_insured_age = await computeAge(
          this.$store.state.userInfo.id,
          moment(tempNowSelectProposal.insured_birthday).format("YYYY-MM-DD"),
        );
        if (
          parseInt(res_new_insured_age.body.age) !=
          parseInt(tempNowSelectProposal.insured_age)
        ) {
          isAddAge_noId = true;
        }
      }
      if (
        tempNowSelectProposal.insured_id == "" &&
        tempNowSelectProposal.insurer_birthday &&
        !isAddAge_noId
      ) {
        let res_new_insurer_age = await computeAge(
          this.$store.state.userInfo.id,
          moment(tempNowSelectProposal.insurer_birthday).format("YYYY-MM-DD"),
        );
        if (
          parseInt(res_new_insurer_age.body.age) !=
          parseInt(tempNowSelectProposal.insurer_age)
        ) {
          isAddAge_noId = true;
        }
      }

      for (let i = 0; i < tempNowSelectProposal.mc_prod_list.length; i++) {
        let mc = tempNowSelectProposal.mc_prod_list[i];
        mc.riskObj = this.kycRiskObjText;
        if (typeof mc.fund == "string") {
          mc.fund = JSON.parse(mc.fund);
        }
        if (mc.stop_sale == "1") {
          isStopSale = true;
          tempNowSelectProposal.mc_prod_list.splice(i, 1);
          autoDeleteSet.add(`${mc.prod_name}(${mc.prod_id})`);
          i--;
          continue;
        }
        for (let j = 0; j < mc.sc_prod_list.length; j++) {
          let sc = mc.sc_prod_list[j];
          sc.is_checked = "1";
          if (sc.stop_sale == "1") {
            isStopSale = true;
            mc.sc_prod_list.splice(j, 1);
            autoDeleteSet.add(`${sc.prod_name}(${sc.prod_id})`);
            j--;
          } else if (
            tempNowSelectProposal.insured_id == "" &&
            sc.insured_birthday &&
            !isAddAge_noId
          ) {
            //空白建議書，要額外判斷增齡，若該商品被停售，則不判斷，因此放在這
            let res_new_insured_age = await computeAge(
              this.$store.state.userInfo.id,
              moment(sc.insured_birthday).format("YYYY-MM-DD"),
            );
            if (
              parseInt(res_new_insured_age.body.age) != parseInt(sc.insured_age)
            ) {
              isAddAge_noId = true;
            }
          }
        }
      }
      if (isStopSale && mode != "edit") {
        return this.$mfNotice(
          "本份建議書包含已停售商品!",
          null,
          false,
          null,
          "確定",
          "依本公司商品銷售文件規範，商品建議書僅可作為行銷時協助客戶了解商品內容之輔助說明文件，故商品停售後，建議書及內含之各試算數值均不得繼續產製、匯入行動投保等操作。 <br><br>如欲刪除停售商品，點擊「修改建議書」刪除該商品。",
        );
      } else if (isAddAge_noId) {
        return this.$mfNotice(
          "本份建議書的試算客戶已增齡!",
          null,
          false,
          null,
          "確定",
          "客戶已增齡，請至「新增/輸入」頁籤重新試算",
        );
      }
      //判斷完停售以及CRM異動後，進行下一步動作。
      let to = (tempNowSelectProposal) => {
        return () => {
          this.changePopupHandler = false;
          if (isRouteToCustDetail && mode !== "edit") {
            this.routeToCustDetail(routeToCustDetailId);
            return;
          }
          let isNoId =
            tempNowSelectProposal.insurer_id === null ||
            tempNowSelectProposal.insurer_id === undefined ||
            tempNowSelectProposal.insurer_id === "";
          let proposalData = {
            NO: tempNowSelectProposal.NO,
            prod_idx: tempNowSelectProposal.prod_idx,
            insured: {
              insured_age: tempNowSelectProposal.insured_age,
              insured_birthday: tempNowSelectProposal.insured_birthday,
              insured_gender: tempNowSelectProposal.insured_gender,
              insured_id: tempNowSelectProposal.insured_id,
              insured_name: tempNowSelectProposal.insured_name,
            },
            insurer: {
              insured_age: tempNowSelectProposal.insurer_age,
              insured_birthday: tempNowSelectProposal.insurer_birthday,
              insured_gender: tempNowSelectProposal.insurer_gender,
              insured_id: tempNowSelectProposal.insurer_id,
              insured_name: tempNowSelectProposal.insurer_name,
            },
            inputType: isNoId ? "noId" : "family",
            sameInsurer: this.isSameInsuredAndInsurer(
              tempNowSelectProposal,
              isNoId,
            ),
            mc_prod_list: tempNowSelectProposal.mc_prod_list,
            sc_prod_id_list: tempNowSelectProposal.sc_prod_id_list,
            //戶長ID作為家戶ID，為了要取得MemberList
          };
          let family = this.getAllFamilyResult.find((item) => {
            return item.csidno == this.nowShowInsuredId;
          });
          this.$store.commit("update_MfViewing", {
            ...proposalData,
            prod_idx: proposalData.prod_idx,
            saveData: tempNowSelectProposal,
            familyid: (family && family.familyid) || "",
          });
          this.$store.commit("update_queryDetailTarget", {
            is_crm: this.is_crm,
            insured_id: tempNowSelectProposal.insured_id,
            prod_idx: this.is_crm == "0" ? this.prod_idx : "",
            familyid: (family && family.familyid) || "",
          });
          let selectedProposal = this.proposal_item; // 轉頁 2-5 print 另存資料
          let WarnText = "";

          if (!this.isIUL && !isRouteToCustDetail) {
            WarnText = this.insuredRiskWarnText(
              this.nowSelectProposal.insurer_id,
              "importMobile",
              this.proposal_item,
            ); // 匯入投保判斷風險屬性是否有文字
          }

          switch (mode) {
            case "edit":
              this.$store.commit("update_MfEditing", proposalData);
              this.$router.push("/mf/create");
              return;
            case "print":
              this.$store.commit("set_proRiskObj", selectedProposal),
                this.$router.push("/mf/printProposal");
              return;
            case "importMobile":
              // if (this.$store.getters.BuTest) return;
              if (this.isIV && WarnText !== "") {
                return this.$toast.info({
                  title: this.insuredRiskWarnText(
                    this.nowSelectProposal.insurer_id,
                    "importMobile",
                    this.proposal_item,
                  ),
                });
              }
              this.$router.push("/mf/importMobile");
              return;
            case "importInsurance":
              if (this.$store.getters.BuTest) return;
              this.$router.push("/mf/importInsurance");
              return;
            case "performaceTable":
              this.$router.push("/mf/performace/recommendedProduct");
              return;
            case "eReview":
              if (this.includeNoId) {
                return this.$toast.info({
                  title: `需要被保人已於CRM輸入身分證字號，才能使用E檢核功能`,
                });
              }
              this.$mfAPI
                .MFA0_2000__eCheck({
                  proposalList: [this.nowSelectProposal],
                })
                .then((res) => {
                  let formData = {};
                  formData.AGENT_ID1 = this.$store.state.userInfo.id;
                  formData.ID = this.nowSelectProposal.insured_id;
                  formData.NAME = this.nowSelectProposal.insured_name;
                  formData.BIRTHDAY = this.nowSelectProposal.insured_birthday;
                  formData.GENDER = this.nowSelectProposal.insured_gender;
                  formData.TxRequest = true;
                  formData.queryType = 1;
                  formData.subcode = "ATA0";
                  formData.syscode = "AT";
                  formData.HEALTH_PROD_ID = res.health_prod_id || "";
                  formData.FIX_PROD_ID = res.fix_prod_id || "";
                  formData.FREE_FACE_AMT = res.free_face_amt;
                  formData.FREE_PROD_ID = res.free_prod_id || "";
                  formData.FIX_FACE_AMT = res.fix_face_amt || 0;
                  formData.IS_ASSURED_FREE = res.fix_face_amt || 0;
                  formData.IS_HEALTH = res.is_health;
                  formData.HEALTH_FACE_AMT = res.health_face_amt;

                  let fromElement = this.$refs.submit;
                  let url = fromElement.action + "?";
                  fromElement.replaceChildren();
                  for (let keyName in formData) {
                    let opt = document.createElement("textarea");
                    opt.name = keyName;
                    opt.value = formData[keyName];
                    url += `${keyName}=${formData[keyName]}&`;
                    fromElement.appendChild(opt);
                  }

                  this.nowSelectProposal.mc_prod_list.forEach((mc) => {
                    let opt_prod_id = document.createElement("textarea");
                    opt_prod_id.name = "PROD_ID";
                    opt_prod_id.value = mc.prod_id;
                    url += `${opt_prod_id.name}=${opt_prod_id.value}&`;
                    fromElement.appendChild(opt_prod_id);

                    let opt_amt = document.createElement("textarea");
                    opt_amt.name = "FACE_AMT";
                    opt_amt.value = mc.amt;
                    url += `${opt_amt.name}=${opt_amt.value}&`;
                    fromElement.appendChild(opt_amt);

                    let opt_amt_unit = document.createElement("textarea");
                    opt_amt_unit.name = "FACE_AMT_UNIT";
                    opt_amt_unit.value = mc.amt_unit;
                    url += `${opt_amt_unit.name}=${opt_amt_unit.value}&`;
                    fromElement.appendChild(opt_amt_unit);

                    let opt_pay_prd = document.createElement("textarea");
                    opt_pay_prd.name = "PAY_PERIOD";
                    opt_pay_prd.value = mc.pay_prd;
                    url += `${opt_pay_prd.name}=${opt_pay_prd.value}&`;
                    fromElement.appendChild(opt_pay_prd);

                    let opt_pol_period = document.createElement("textarea");
                    opt_pol_period.name = "POL_PERIOD";
                    opt_pol_period.value = mc.pol_period;
                    url += `${opt_pol_period.name}=${opt_pol_period.value}&`;
                    fromElement.appendChild(opt_pol_period);
                  });
                  if (this.$store.state.userInfo.userType === "box") {
                    window.webkit.messageHandlers.getECheckUrl.postMessage(url);
                  } else {
                    fromElement.submit();
                  }
                });

              return;
          }
        };
      };
      //CRM異動判斷
      let customStatusCheck = async () => {
        this.oldCrmMapList = {};
        let needShowChangePopup = false;
        let crmMapList = this.crmMapList;
        //開始判斷建議書資料對比，要保人 insurer_id
        let insurer_id = this.nowSelectProposal.insurer_id;
        if (!crmMapList[insurer_id]) {
          //被保人離開不在這個家戶 因此做例外處理
          let theCust = await getCustInfo(
            this.$store.state.userInfo.id,
            this.$store.state.userInfo.id,
            insurer_id,
          );
          if (theCust.body.customer) {
            //有找到
            crmMapList[insurer_id] = {
              insured_name: theCust.body.customer.name,
              insured_birthday: theCust.body.customer.birthday || "",
              insured_gender: theCust.body.customer.sex,
              insured_age: theCust.body.customer.age + "",
            };
          } else {
            //找不到
            this.$toast.info({
              title: `${this.nowSelectProposal.insurer_name}找不到資料`,
            });
          }
        }
        if (
          tempNowSelectProposal.insurer_name !=
            crmMapList[insurer_id].insured_name ||
          tempNowSelectProposal.insurer_gender !=
            crmMapList[insurer_id].insured_gender ||
          tempNowSelectProposal.insurer_age !=
            crmMapList[insurer_id].insured_age ||
          (tempNowSelectProposal.insurer_birthday || "") !=
            crmMapList[insurer_id].insured_birthday
        ) {
          needShowChangePopup = true;
          this.oldCrmMapList[insurer_id] = {
            insured_name: tempNowSelectProposal.insurer_name,
            insured_birthday: tempNowSelectProposal.insurer_birthday || "",
            insured_gender: tempNowSelectProposal.insurer_gender,
            insured_age: tempNowSelectProposal.insurer_age + "",
            is_insurer: true,
          };
          //更新建議書資訊
          tempNowSelectProposal.insurer_name =
            crmMapList[insurer_id].insured_name;
          tempNowSelectProposal.insurer_gender =
            crmMapList[insurer_id].insured_gender;
          tempNowSelectProposal.insurer_age =
            crmMapList[insurer_id].insured_age;
          tempNowSelectProposal.insurer_birthday =
            crmMapList[insurer_id].insured_birthday;
        }
        //開始判斷建議書資料對比，主約被保人 insured_id
        let mcInsured_id = this.nowSelectProposal.insured_id;
        if (
          tempNowSelectProposal.insured_name !=
            crmMapList[mcInsured_id].insured_name ||
          tempNowSelectProposal.insured_gender !=
            crmMapList[mcInsured_id].insured_gender ||
          tempNowSelectProposal.insured_age !=
            crmMapList[mcInsured_id].insured_age ||
          tempNowSelectProposal.insured_gender !=
            crmMapList[mcInsured_id].insured_gender ||
          (tempNowSelectProposal.insured_birthday || "") !=
            crmMapList[mcInsured_id].insured_birthday
        ) {
          needShowChangePopup = true;
          this.oldCrmMapList[mcInsured_id] =
            this.oldCrmMapList[mcInsured_id] || {};
          this.oldCrmMapList[mcInsured_id].insured_name =
            tempNowSelectProposal.insured_name;
          this.oldCrmMapList[mcInsured_id].insured_birthday =
            tempNowSelectProposal.insured_birthday || "";
          this.oldCrmMapList[mcInsured_id].insured_gender =
            tempNowSelectProposal.insured_gender;
          this.oldCrmMapList[mcInsured_id].insured_age =
            tempNowSelectProposal.insured_age + "";
          this.oldCrmMapList[mcInsured_id].is_insured = true;
          //更新建議書資訊
          tempNowSelectProposal.insured_name =
            crmMapList[mcInsured_id].insured_name;
          tempNowSelectProposal.insured_gender =
            crmMapList[mcInsured_id].insured_gender;
          tempNowSelectProposal.insured_age =
            crmMapList[mcInsured_id].insured_age;
          tempNowSelectProposal.insured_birthday =
            crmMapList[mcInsured_id].insured_birthday || "";
        }
        //開始判斷建議書主約~附約被保險人
        for (let i = 0; i < tempNowSelectProposal.mc_prod_list.length; i++) {
          //幫主約壓上更新後的資料，這邊不需要重算保費，因為存檔的時候會計算
          let mc = tempNowSelectProposal.mc_prod_list[i];
          mc.insured_name = crmMapList[mcInsured_id].insured_name;
          mc.insured_gender = crmMapList[mcInsured_id].insured_gender;
          mc.insured_age = crmMapList[mcInsured_id].insured_age;
          mc.insured_birthday = crmMapList[mcInsured_id].insured_birthday;
          for (let j = 0; j < mc.sc_prod_list.length; j++) {
            let sc = mc.sc_prod_list[j];
            let scInsured_id = sc.insured_id;
            //如果附約被保險人搬家或被砍掉
            if (!crmMapList[scInsured_id]) {
              //被保人離開不在這個家戶 因此做例外處理
              let theCust = await getCustInfo(
                this.$store.state.userInfo.id,
                this.$store.state.userInfo.id,
                scInsured_id,
              );
              if (theCust.body.customer) {
                //有找到
                crmMapList[scInsured_id] = {
                  insured_name: theCust.body.customer.name,
                  insured_birthday: theCust.body.customer.birthday || "",
                  insured_gender: theCust.body.customer.sex,
                  insured_age: theCust.body.customer.age + "",
                };
              } else {
                //找不到
                this.$toast.info({
                  title: `${sc.insured_name}找不到資料`,
                });
              }
            }
            if (
              sc.insured_name != crmMapList[scInsured_id].insured_name ||
              sc.insured_gender != crmMapList[scInsured_id].insured_gender ||
              sc.insured_age != crmMapList[scInsured_id].insured_age ||
              sc.insured_gender != crmMapList[scInsured_id].insured_gender ||
              sc.insured_birthday != crmMapList[scInsured_id].insured_birthday
            ) {
              needShowChangePopup = true;
              this.oldCrmMapList[scInsured_id] =
                this.oldCrmMapList[scInsured_id] || {};
              this.oldCrmMapList[scInsured_id].insured_name = sc.insured_name;
              this.oldCrmMapList[scInsured_id].insured_birthday =
                sc.insured_birthday || "";
              this.oldCrmMapList[scInsured_id].insured_gender =
                sc.insured_gender;
              this.oldCrmMapList[scInsured_id].insured_age =
                sc.insured_age + "";
              this.oldCrmMapList[scInsured_id].is_scInsured = true;
              //幫附約壓上更新後的資料並重新計算保費
              sc.insured_name = crmMapList[scInsured_id].insured_name;
              sc.insured_gender = crmMapList[scInsured_id].insured_gender;
              sc.insured_age = crmMapList[scInsured_id].insured_age;
              sc.insured_birthday =
                crmMapList[scInsured_id].insured_birthday || "";
              //計算
              try {
                let { premium } = await this.$mfAPI.MFC0_1000__getPremium({
                  ...sc,
                  pay_prd: sc.pay_prd,
                  pol_period: mc.pol_period,
                  pay_freq: mc.pay_freq,
                  insured_age: crmMapList[scInsured_id].insured_age,
                  insured_gender: crmMapList[scInsured_id].insured_gender,
                });
                sc.premium = premium;
              } catch {
                //取不到保費，考慮是否直接把該附約過濾掉
              }
            }
            ///
          }
        }
        if (needShowChangePopup) {
          mode = "edit";
          this.changePopupHandler = true;
          this.tempNowSelectProposal = _.cloneDeep(tempNowSelectProposal);
          this.toHandler = to(tempNowSelectProposal);
        } else {
          to(tempNowSelectProposal)();
        }
      };

      //重要!! 停售商品的修改判斷>>需過慮停售商品
      if (isStopSale && mode == "edit") {
        let autoDeleteString = [...autoDeleteSet].join("<br>");
        return this.$mfNotice(
          "以下商品已停售，將自動從「已選商品清單」中剔除(剔除商品若為主約，其附加的附約將一併剔除)：",
          this.nowSelectProposal.insurer_id !== ""
            ? customStatusCheck
            : to(tempNowSelectProposal),
          false,
          null,
          "確定",
          autoDeleteString,
        );
      } else {
        if (this.nowSelectProposal.insured_id != "") {
          //crm家戶
          customStatusCheck();
        } else {
          //空白建議書試算，需判斷是否增加年齡

          to(tempNowSelectProposal)();
        }
      }
    },
    /**
     * 判斷要保人與被保險人是否為同一人
     * @param {object} tempNowSelectProposal - 暫存資料
     * @param {boolean} isNoId - 是否無ID(空白建議書)
     * @returns {boolean} - 是否為同一人
     */
    isSameInsuredAndInsurer(tempNowSelectProposal, isNoId) {
      const {
        insured_age,
        insurer_age,
        insured_gender,
        insurer_gender,
        insured_name,
        insurer_name,
        insured_birthday,
        insurer_birthday,
        insured_id,
        insurer_id,
      } = tempNowSelectProposal;

      if (!isNoId) {
        return insured_id === insurer_id;
      }

      // 基本欄位比對：年齡、性別、姓名
      const basicMatch =
        insured_age === insurer_age &&
        insured_gender === insurer_gender &&
        insured_name === insurer_name;

      // 若有輸入生日則比對insured_birthday；否則比對年齡
      const birthdayMatch =
        insured_birthday != null
          ? insured_birthday === insurer_birthday
          : insured_age === insurer_age;

      return basicMatch && birthdayMatch;
    },

    deleteProposal() {
      if (!this.nowSelectProposal) {
        return this.$toast.info({ title: `請先選擇一組建議!` });
      }
      this.$mfNotice(
        "您確定要刪除這份建議書嗎?",
        async () => {
          switch (this.nowSelectProposal.prod_type) {
            case "2":
              //投資型刪除
              //傳統型刪除
              await this.$mfAPI.MFA1_1000__deleteProposal({
                prod_idx: this.nowSelectProposal.prod_idx,
              });
              this.proposalDetailList_IV = this.proposalDetailList_IV.filter(
                (item) => item.prod_idx !== this.nowSelectProposal.prod_idx,
              );
              break;
            case "5":
              //指數型刪除
              await this.$mfAPI.MFA1_1000__deleteProposal({
                prod_idx: this.nowSelectProposal.prod_idx,
              });
              this.proposalDetailList_IV = this.proposalDetailList_IV.filter(
                (item) => item.prod_idx !== this.nowSelectProposal.prod_idx,
              );
              break;
            default:
              //傳統型刪除
              await this.$mfAPI.MFA0_1000__deleteProposal({
                prod_idx: this.nowSelectProposal.prod_idx,
              });
              this.proposalDetailList_TD = this.proposalDetailList_TD.filter(
                (item) => item.prod_idx !== this.nowSelectProposal.prod_idx,
              );
          }
          this.$toast.info({
            title: `刪除成功!`,
          });
          this.nowSelectProposal = null;
          this.$forceUpdate();
        },
        true,
      );
    },
    selectContractDateHandler($event) {
      // 所選的建議書
      if ($event.insurer_id === "") {
        // 空白建議書
        let riskObj = {
          kyc_message:
            "要保人近一年無有效風險屬性，建議書僅可內部使用，會以浮水印提醒不得對外行銷使用",
        };
        this.$store.commit("set_kycRiskObj", riskObj);
      } else {
        this.$store.commit(
          "set_kycRiskObj",
          this.memberRiskObjList[$event.insurer_id],
        );
      }
      $event.mc_prod_list[0].riskObj =
        this.memberRiskObjList[$event.insurer_id];
      this.proposal_item = $event.mc_prod_list[0];
      if ($event.prod_type != "1") {
        let length = this.proposal_item.sc_prod_list
          ? this.proposal_item.sc_prod_list.length
          : 0;
        this.proposal_IV_SC_length = length;
      }
      this.nowSelectProposal = $event;
    },
  },
};
</script>

<style lang="scss">
.queryDetail {
  @media (min-width: 1025px) {
    /* width: 1280px !important; */
    max-width: 1280px;
    width: 100%;
  }
  .selectInsered {
    border-bottom: solid 1px #c2c4c7;
    &__list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .inseredTab {
        width: 172px;
        display: flex;
        padding: 10px;
        border-radius: 25px;
        border: solid 1px #c2c4c7;
        background-color: #fff;
        cursor: pointer;
        &__name {
          flex-grow: 1;
          text-align: center;
        }
        &.active {
          border: solid 1px #f58818;
          background-color: #feeedd;
        }
      }
    }
  }
  &__title {
    display: flex;
    align-items: center;
    &--tag {
      width: 8px;
      height: 24px;
      margin: 0 4px 1px 0;
    }
  }
}
.queryDetail__empty {
  min-height: 55vh;
  margin-bottom: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #323a45;
}
</style>
